export default {
  methods: {
    linkAllImgUrl(url) {
      let str = '';
      if (url) {
        if (/^(http|https)/.test(url)) {
          str = url;
        } else {
          str = `${process.env.VUE_APP_IMG_URL}${url}`
        }
      }
      return str;
    }
  }
}